module.exports = __webpack_public_path__ + "static/berkhof-digital-f6ab6aabd54b72ccf789af4669e47b2e.svg";